module.exports = __webpack_public_path__ + "img/vietnam-flag-icon-free-download.b1f7975d.jpg";